import { buildDownloadData } from '@/pages/intelligence/utils/commonUtils';
export const dealDownLoadData = (data?: any)=> {
  const config: any = {};
  config.stat = {
    sheetName: 'Stats',
    style: 'normal',
    data: buildDownloadData(
      (data?.columns || []).map((item: any) => {
        const valueKey = item?.dataIndex || item?.key;
        return {
          title: item?.title || item?.header,
          key: (row: any) => {
            const value = valueKey ? row?.[valueKey] : undefined;
            if (item?.format) {
              return value !== undefined && value !== null
                ? item.format(value)
                : '';
            }
            return value !== undefined && value !== null ? value : '';
          },
        };
      }),
      data?.data || []
    ),
  };

  // summary 直接用二维结果写
  config.summary = {
    sheetName: 'Summary',
    style: 'summary',
    data: [
      ['searchKey', ''],
      ['Date Start', ''],
      ['Date End', ''],
    ],
  };

  return config;
};